import AnnouncementBar from "@/components/aeonyx/AnnouncementBar";
import Header from "@/components/aeonyx/Header";
import Footer from "@/components/aeonyx/Footer";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useScrollReveal } from "@/lib/useScrollReveal";

export default function DosageCalculator() {
  useScrollReveal();
  return (
    <div className="bg-cool-white min-h-screen">
      <AnnouncementBar />
      <Header />
      <section className="py-24 sm:py-32">
        <div className="max-w-3xl mx-auto px-5 lg:px-8">
          <div className="overline text-cyan-brand">Dosage Calculator</div>
          <h1 className="font-display mt-4 text-4xl md:text-5xl font-bold text-navy-deep">
            Reconstitution & concentration reference.
          </h1>
          <p className="mt-4 text-slate-600">
            For laboratory reference only. Aeonyx does not provide medical dosing
            guidance.
          </p>

          <div className="mt-10 rounded-3xl bg-white border border-[#8A97A8]/25 p-8 space-y-5">
            <div>
              <Label htmlFor="peptide" className="text-navy-deep">Peptide amount (mg)</Label>
              <Input id="peptide" type="number" placeholder="5" className="mt-1.5 h-11 rounded-xl" />
            </div>
            <div>
              <Label htmlFor="solvent" className="text-navy-deep">Bacteriostatic water (mL)</Label>
              <Input id="solvent" type="number" placeholder="2" className="mt-1.5 h-11 rounded-xl" />
            </div>
            <div>
              <Label htmlFor="target" className="text-navy-deep">Target research dose (mcg)</Label>
              <Input id="target" type="number" placeholder="250" className="mt-1.5 h-11 rounded-xl" />
            </div>
            <Button
              disabled
              data-testid="calc-btn"
              className="w-full h-12 rounded-full bg-navy-deep text-white opacity-50 cursor-not-allowed"
            >
              Calculate (available soon)
            </Button>
            <p className="text-xs text-cool-grey">
              This scaffold is provided for interface preview. Aeonyx does not
              endorse any specific dosing regimen.
            </p>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
